import { computed } from "vue";

const filterEntries = (
  entries,
  store,
  categoryID,
  filterValues = [],
  searchFilterInput = null
) => {
  const category = computed(() => store.getters["api/category"](categoryID));

  const isRecordLayout = computed(() =>
    ["RecordsRowsLayout", "RecordsColumnsLayout"].includes(
      category.value.layout
    )
  );

  const excludeNewProfiles = (item) => !(item.firstName === "NEW PROFILE");

  const onlyShowLiveEntries = (item) => {
    if (!store.getters.showCMS && !isRecordLayout.value) {
      // if not CMS, only show live entries and exclude NEW PROFILE
      return excludeNewProfiles(item) && item.isLive;
    }
    return true;
  };

  const passesLastNameFilter = (lastName, filterValue) =>
    lastName.charAt(0) === filterValue && lastName !== "A";

  const passesDateFilter = (date, filterValue) =>
    date != null && date.substring(0, 4) === filterValue;

  const passesActivityOrTypeFilter = (activityOrType, filterValue) => {
    const values = activityOrType
      .toLowerCase()
      .split(/,|\/|\||~/)
      .map((s) => s.trim());
    return values.includes(filterValue.toLowerCase());
  };

  const passesFilter = (item, key, filterValue) => {
    switch (key) {
      case "lastName":
        return passesLastNameFilter(item[key], filterValue);
      case "eventDate":
      case "graduationDate":
        return passesDateFilter(item[key], filterValue);
      case "activity":
      case "type":
        return passesActivityOrTypeFilter(item[key], filterValue);
      default:
        return true;
    }
  };

  const searchFilter = (item) => {
    const values = Object.values(item).map((val) =>
      val === null || val === undefined ? "" : String(val)
    );
    const input = searchFilterInput.trim().toLowerCase();
    return (
      values.some((str) => str.toLowerCase().includes(input)) ||
      values.some((str) => input.split(" ").includes(str.toLowerCase()))
    );
  };

  const dropdownFilter = (item) =>
    Object.entries(filterValues).reduce(
      (include, [key, value]) =>
        include && (value === null || passesFilter(item, key, value)),
      true
    );

  return entries
    .filter(onlyShowLiveEntries)
    .filter(searchFilterInput ? searchFilter : dropdownFilter);
};

export { filterEntries };
